import IconButton from '@zenbusiness/zui/IconButton';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import PropTypes from 'prop-types';

import { DialogContentTextStyled, DialogHeaderStyled, DialogStyled } from '../ConfirmModal.styles';

const CloseIcon = (
  <SharedAsset
    alt=""
    src="/icon/micro/close-x.svg"
  />
);

export default function ConfirmModalDesktopView({ children, handleClose }) {
  return (
    <DialogStyled
      disableRestoreFocus
      onClose={handleClose}
      open
    >
      <DialogHeaderStyled>
        <IconButton
          label="close"
          onClick={handleClose}
        >
          {CloseIcon}
        </IconButton>
      </DialogHeaderStyled>
      <DialogContentTextStyled component="div">{children}</DialogContentTextStyled>
    </DialogStyled>
  );
}

ConfirmModalDesktopView.propTypes = {
  children: PropTypes.node.isRequired,
  handleClose: PropTypes.func.isRequired
};
